import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {filter, merge, switchMap, tap} from 'rxjs';
import {AccountCreatedEvent} from 'src/app/shared/application/events/account/account-created.event';
import {AccountSelectedEvent} from 'src/app/shared/application/events/account/account-selected.event';
import {EVENT_BUS} from 'src/app/shared/domain/tokens/event-bus.token';
import {GetLastSimpleTicketService} from '../services/get-last-simple-ticket.service';
import {TicketEventsService} from '../services/events.service';

@Injectable()
export class GetLastSimpleTicketSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly getLastTicket = inject(GetLastSimpleTicketService);
  private readonly ticketEventsService = inject(TicketEventsService);

  constructor() {
    merge(
      this.eventBus.ofType(AccountSelectedEvent),
      this.eventBus.ofType(AccountCreatedEvent)
    )
      .pipe(
        switchMap(() => this.getLastTicket.execute()),
        filter((ticket) => ticket !== null),
        tap((ticket) => this.ticketEventsService.emitTicketUpdated(ticket)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
